module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/63.51f9456c.png";